import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RoleTypeEnum } from '@cyberlabrs/helpers';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { selectUserRole } from '../../../store/slices/auth.slice';
import { AUTHORIZED_PM_TEAM_LEAD } from '../../../constants';

const useHttpGetMembersOfLeadsTeamOnMount = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const roleName = useSelector(selectUserRole)?.name as RoleTypeEnum | undefined;
    const isTeamScopedRole = !!roleName && AUTHORIZED_PM_TEAM_LEAD.includes(roleName);

    const [memberSubs, setMemberSubs] = useState<string[]>([]);
    const [isReady, setIsReady] = useState(!isTeamScopedRole);

    useEffect(() => {
        if (!isTeamScopedRole) {
            setIsReady(true);
            return undefined;
        }

        const { exec, abort } = organizationApi.getMembersOfLeadsTeam({
            invalidCacheTime: 5 * 60 * 1000,
            onSuccess: res => setMemberSubs(res.body),
            onError: () => setMemberSubs([]),
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    }, [organizationApi, isTeamScopedRole]);

    return { memberSubs, isReady, isTeamScopedRole };
};

export default useHttpGetMembersOfLeadsTeamOnMount;
